import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFocusHandleOnClose, useFocusTrap } from '@prophecy/utils/react/focus';
import { useControlledState } from '@prophecy/utils/react/hooks';
import { Arrow, Portal, Root, Trigger } from '@radix-ui/react-popover';
import { resolveCssVariable, theme } from '../theme';
import { PopoverContent } from './styled';
export const POPOVER_CONTENT_WRAPPER = 'data-radix-popper-content-wrapper';
export function Popover({ overlay, visible, onVisibleChange, children, overlayClassName, overlayStyle, arrow, placement: side = 'bottom', placementOffset: sideOffset = parseInt(resolveCssVariable(theme.spaces.x8), 10), align, alignOffset, onOpenAutoFocus, onCloseAutoFocus, portalled = true, avoidCollisions, hideWhenDetached, onInteractOutside, onPointerDownOutside, 'data-test-id': dataTestId }) {
    const [_visible, toggleVisible] = useControlledState({
        value: visible,
        onChange: onVisibleChange
    });
    const container = useFocusTrap(Boolean(_visible));
    const defaultOnCloseAutoFocus = useFocusHandleOnClose(Boolean(_visible));
    const content = /*#__PURE__*/ _jsx(PopoverContent, {
        asChild: true,
        className: overlayClassName,
        style: overlayStyle,
        side: side,
        align: align,
        sideOffset: sideOffset,
        alignOffset: alignOffset,
        ref: container,
        tabIndex: -1,
        onOpenAutoFocus: onOpenAutoFocus,
        hideWhenDetached: hideWhenDetached,
        onCloseAutoFocus: onCloseAutoFocus ?? defaultOnCloseAutoFocus,
        onInteractOutside: onInteractOutside,
        onPointerDownOutside: onPointerDownOutside,
        avoidCollisions: avoidCollisions,
        "data-test-id": dataTestId,
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                arrow && /*#__PURE__*/ _jsx(Arrow, {}),
                overlay
            ]
        })
    });
    return /*#__PURE__*/ _jsxs(Root, {
        open: _visible,
        onOpenChange: toggleVisible,
        children: [
            /*#__PURE__*/ _jsx(Trigger, {
                asChild: true,
                "data-test-id": `${dataTestId}-trigger`,
                children: children
            }),
            portalled ? /*#__PURE__*/ _jsx(Portal, {
                children: content
            }) : content
        ]
    });
}
